import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';

import { DEFAULT_LANGUAGE, isSupportedLanguage } from '../../i18n/config';
import { localizePath } from '../../i18n/languagePath';

/**
 * Racine des routes "/:lang/*" : la langue de l'URL est la source de vérité. Un premier
 * segment qui n'est pas une langue supportée ("/home") est traité comme une URL sans langue
 * et redirigé vers la langue détectée ("/fr/home"). L'habillage (header, footer) est assuré
 * par MainLayout, route enfant de celle-ci.
 */
export default function LanguageLayout() {
    const { lang } = useParams();
    const { i18n } = useTranslation();
    const { pathname, search, hash } = useLocation();

    useEffect(() => {
        if (isSupportedLanguage(lang) && i18n.resolvedLanguage !== lang) {
            void i18n.changeLanguage(lang);
        }
    }, [lang, i18n]);

    if (!isSupportedLanguage(lang)) {
        const detected = isSupportedLanguage(i18n.resolvedLanguage)
            ? i18n.resolvedLanguage
            : DEFAULT_LANGUAGE;
        return <Navigate to={`${localizePath(detected, pathname)}${search}${hash}`} replace />;
    }

    return <Outlet />;
}
